import React from 'react';
import styled from '@emotion/styled';
import { JourneyNavigationHandler, Routes } from '../../../routes';
import { BillingDetailsForm } from '../manage-subscriptions/widgets/billing/BillingDetailsForm';
import { CenterFormWidget } from '../../../widgets/layout/CenterFormWidget';

export interface BillingDetailsDialogProps {
  handler: JourneyNavigationHandler<Routes.BILLING_SETTINGS>;
}

export const BillingDetailsDialog: React.FC<BillingDetailsDialogProps> = ({ handler }) => {
  return (
    <S.Container noLogo={true} primaryLabel="Billing details">
      <BillingDetailsForm
        backButton="Cancel"
        onNext={() => {
          handler.navigate(Routes.BILLING, { ...handler.params });
        }}
        onBack={() => {
          handler.navigate(Routes.BILLING, { ...handler.params });
        }}
      />
    </S.Container>
  );
};

namespace S {
  export const Container = styled(CenterFormWidget)`
    width: 700px;
    max-width: 700px;
  `;
}
